<app-base-modal [title]="titleText">
  <div class="wrapper">
    <div
      class="description"
      [innerHTML]="description"
    ></div>
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        (click)="closeDialog('cancel')"
      >
        {{ buttonPrimaryText || 'Назад' }}
      </button>
      <button
        mat-button
        color="warn"
        (click)="closeDialog('remove')"
      >
        {{ buttonWarmText }}
      </button>
    </div>
  </div>
</app-base-modal>
